import { Button, Col, Divider, Form, Input, InputNumber, Row, Select, Tooltip } from 'antd'
import {
  UserOutlined,
  InfoCircleOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons'
import { useForm } from 'antd/es/form/Form'
import { toast, ToastContainer } from 'react-toastify'
import './style.css'
import {
  GiAngelOutfit,
  GiSnake,
  GiPoliceBadge,
  GiThreeFriends,
  GiJigsawPiece,
  GiBrain,
  GiWeightLiftingUp,
  GiMuscleUp,
  GiSmart,
  GiArcheryTarget,
  GiSpy,
  GiFist,
  GiDiscobolus,
  GiBrainFreeze,
  GiBookCover,
  GiComputing,
  GiToolbox,
  GiMagnifyingGlass,
  GiHealthNormal,
  GiPentacle,
  GiDiploma,
  GiAtom,
  GiSwordsEmblem,
  GiCityCar,
  GiKimono,
  GiIdCard,
  GiPistolGun,
  GiPayMoney,
  GiNinjaHead,
  GiJumpAcross,
  GiCampfire,
  GiSittingDog,
  GiCherish,
  GiVitruvianMan,
  GiAngryEyes,
  GiConversation,
  GiShakingHands,
  GiDominoMask,
  GiRobber,
  GiClover,
  GiSkullCrack,
  GiBodyHeight,
  GiSpeedometer,
  GiStairsGoal,
  GiSurroundedShield,
  GiChestArmor,
  GiClockwork,
  GiHearts,
  GiDoubleFaceMask,
  GiDove,
} from 'react-icons/gi'
import { useAuth } from '@aws-amplify/ui-react/internal'
import { useCreateCharacterMutation } from '../../store'
import { useNavigate } from 'react-router-dom'
import { Overlay } from '../../components/Overlay'
import { useEffect } from 'react'

const skillsOptions = [
  { value: 0, label: 'Academics', indexer: 'academics' },
  { value: 1, label: 'Computer', indexer: 'computer' },
  { value: 2, label: 'Crafts', indexer: 'crafts' },
  { value: 3, label: 'Investigation', indexer: 'investigation' },
  { value: 4, label: 'Medicine', indexer: 'medicine' },
  { value: 5, label: 'Occult', indexer: 'occult' },
  { value: 6, label: 'Politics', indexer: 'politics' },
  { value: 7, label: 'Science', indexer: 'science' },
  { value: 8, label: 'Athletics', indexer: 'athletics' },
  { value: 9, label: 'Brawl', indexer: 'brawl' },
  { value: 10, label: 'Drive', indexer: 'drive' },
  { value: 11, label: 'Firearms', indexer: 'firearms' },
  { value: 12, label: 'Larceny', indexer: 'larceny' },
  { value: 13, label: 'Stealth', indexer: 'stealth' },
  { value: 14, label: 'Survival', indexer: 'survival' },
  { value: 15, label: 'Weaponry', indexer: 'weaponry' },
  { value: 16, label: 'Animal Ken', indexer: 'animalken' },
  { value: 17, label: 'Empathy', indexer: 'empathy' },
  { value: 18, label: 'Expression', indexer: 'expression' },
  { value: 19, label: 'Intimidation', indexer: 'intimidation' },
  { value: 20, label: 'Persuasion', indexer: 'persuasion' },
  { value: 21, label: 'Socialize', indexer: 'socialize' },
  { value: 22, label: 'Streetwise', indexer: 'streetwise' },
  { value: 23, label: 'Subterfuge', indexer: 'subterfuge' },
]

const defaultTriggers = ['onChange', 'onBlur']

export const CreateCharacterPage = () => {
  const [form] = useForm()
  const [createCharacter, createCharacterRequest] = useCreateCharacterMutation()
  const { user } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (createCharacterRequest.isSuccess) navigate(-1)
  }, [createCharacterRequest])

  const checkTotalSkillPoints = (skills: any[]) => {
    const totalPoints = skills?.reduce((a: any, b: any) => a + b.level, 0)

    if (totalPoints < 22) {
      toast.error(
        `You still have skill points to use! There are ${22 - totalPoints} points missing!`,
      )
      return false
    } else if (totalPoints > 22) {
      toast.info(
        `You are using more points than the default values, is that intended? There are ${
          totalPoints - 22
        } extra points!`,
      )
    }
    return true
  }

  const checkTotalAttributePoints = (character: any) => {
    const { intelligence, strength, presence } = character
    const { wits, dexterity, manipulation } = character
    const { resolve, stamina, composure } = character

    const totalPoints = [
      intelligence,
      strength,
      presence,
      wits,
      dexterity,
      manipulation,
      resolve,
      stamina,
      composure,
    ].reduce((a: number, b: number) => a + b, 0)

    if (totalPoints < 21) {
      toast.error(
        `You still have attribute points to use! There are ${21 - totalPoints} points missing!`,
      )
      return false
    } else if (totalPoints > 21) {
      toast.info(
        `You are using more points than the default values, is that intended? There are ${
          totalPoints - 22
        } extra points! Adjust it later if that was a mistake!`,
      )
    }
    return true
  }

  const onFinish = () => {
    const characterData = form.getFieldsValue()

    const character = {
      name: characterData.name,
      concept: characterData.concept,
      virtue: characterData.virtue,
      vice: characterData.vice,
      age: characterData.age,
      faction: characterData.faction || 'N/A',
      group_name: characterData.group || 'N/A',
      intelligence: characterData.intelligence,
      strength: characterData.strength,
      presence: characterData.presence,
      wits: characterData.wits,
      dexterity: characterData.dexterity,
      manipulation: characterData.manipulation,
      resolve: characterData.resolve,
      stamina: characterData.stamina,
      composure: characterData.composure,
      current_health: characterData.health,
      max_health: characterData.health,
      current_willpower: characterData.willpower,
      max_willpower: characterData.willpower,
      size: characterData.size || 5,
      speed: characterData.speed,
      initiative: characterData.initiative,
      defense: characterData.defense,
      armor: characterData.armor || 0,
      integrity: characterData.integrity,
      experience: characterData.experience || 0,
      avatar: 'man_1',
      chronicle_id: null,
      user_id: user?.username || '',
      skills: skillsOptions?.map((skill) => {
        return {
          description: skill.label,
          level: characterData.skills[skill.value]?.[skill.indexer] || 0,
          specialty:
            characterData.specialties?.find(
              (specialty: any) => specialty.skill_index === skill.value,
            )?.skill_specialty || null,
        }
      }),
      merits:
        characterData.merits?.map((merit: any) => {
          return { description: merit.description, level: merit.level }
        }) || [],
      conditions:
        characterData.conditions?.map((condition: any) => {
          return { description: condition.description, reason: condition.reason }
        }) || [],
    }

    const correctSkillPoints = checkTotalSkillPoints(character.skills)
    const correctAttributePoints = checkTotalAttributePoints(character)

    if (correctSkillPoints && correctAttributePoints) {
      createCharacter(character)
    }
  }

  const calculateHealth = () => {
    const stamina = Number(form.getFieldValue('stamina'))
    const size = Number(form.getFieldValue('size'))

    if (stamina !== 0 && !isNaN(stamina) && size !== 0 && !isNaN(size)) {
      form.setFieldValue('health', stamina + size)
    } else if (stamina !== 0 && !isNaN(stamina)) {
      form.setFieldValue('health', stamina + 5)
    } else {
      form.setFieldValue('health', '')
    }
  }

  const calculateWillpower = () => {
    const resolve = Number(form.getFieldValue('resolve'))
    const composure = Number(form.getFieldValue('composure'))

    if (resolve !== 0 && !isNaN(resolve) && composure !== 0 && !isNaN(composure)) {
      form.setFieldValue('willpower', resolve + composure)
    } else {
      form.setFieldValue('willpower', '')
    }
  }

  const calculateDefense = () => {
    const dexterity = Number(form.getFieldValue('dexterity'))
    const wits = Number(form.getFieldValue('wits'))
    const skills = form.getFieldValue('skills')
    const athletics = Number(skills ? skills[8]?.athletics : NaN)

    if (
      dexterity !== 0 &&
      !isNaN(dexterity) &&
      wits !== 0 &&
      !isNaN(wits) &&
      athletics !== 0 &&
      !isNaN(athletics)
    ) {
      form.setFieldValue('defense', Math.min(dexterity, wits) + athletics)
    } else if (dexterity !== 0 && !isNaN(dexterity) && athletics !== 0 && !isNaN(athletics)) {
      form.setFieldValue('defense', dexterity + athletics)
    } else if (wits !== 0 && !isNaN(wits) && athletics !== 0 && !isNaN(athletics)) {
      form.setFieldValue('defense', wits + athletics)
    } else {
      form.setFieldValue('defense', '')
    }
  }

  const calculateInitiative = () => {
    const dexterity = Number(form.getFieldValue('dexterity'))
    const composure = Number(form.getFieldValue('composure'))

    if (dexterity !== 0 && !isNaN(dexterity) && composure !== 0 && !isNaN(composure)) {
      form.setFieldValue('initiative', dexterity + composure)
    } else {
      form.setFieldValue('initiative', '')
    }
  }

  const calculateSpeed = () => {
    const strength = Number(form.getFieldValue('strength'))
    const dexterity = Number(form.getFieldValue('dexterity'))

    if (dexterity !== 0 && !isNaN(dexterity) && strength !== 0 && !isNaN(strength)) {
      form.setFieldValue('speed', dexterity + strength + 5)
    } else {
      form.setFieldValue('speed', '')
    }
  }

  const makeTooltip = (message: string) => {
    return (
      <Tooltip title={message}>
        <InfoCircleOutlined style={{ fontSize: 24, color: 'rgba(0,0,0,.45)' }} />
      </Tooltip>
    )
  }

  return (
    <Overlay isLoading={createCharacterRequest.isLoading}>
      <Form
        form={form}
        layout={'vertical'}
        initialValues={{ integrity: 7 }}
        onFinish={onFinish}
        validateMessages={{ required: '${label} is required!' }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <h2>Let us know some basic information about your character</h2>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="name"
              label="Name"
              validateTrigger={defaultTriggers}
              rules={[{ required: true, whitespace: true }]}
            >
              <Input
                prefix={<UserOutlined />}
                suffix={makeTooltip('The name people call you')}
                size={'large'}
                style={{ height: 50 }}
                placeholder="Name"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="concept"
              label="Concept"
              validateTrigger={defaultTriggers}
              rules={[{ required: true, whitespace: true }]}
            >
              <Input
                prefix={<GiJigsawPiece />}
                suffix={makeTooltip(
                  'What is the essence of your character? Describe it in 2 or 3 words',
                )}
                size={'large'}
                style={{ height: 50, fontSize: 30 }}
                placeholder="Concept"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="age"
              label="Age"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                prefix={<GiIdCard />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Age'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="virtue"
              label="Virtue"
              validateTrigger={defaultTriggers}
              rules={[{ required: true, whitespace: true }]}
            >
              <Input
                suffix={makeTooltip(
                  'A virtue is a trait that is difficult to act on or easy to ignore, but makes you feel proud when you make the effort. Eg: Honesty, Kindness',
                )}
                prefix={<GiAngelOutfit />}
                size={'large'}
                style={{ height: 50 }}
                placeholder="Virtue"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="vice"
              label="Vice"
              validateTrigger={defaultTriggers}
              rules={[{ required: true, whitespace: true }]}
            >
              <Input
                prefix={<GiSnake />}
                suffix={makeTooltip(
                  'A vice is a trait that represents the easy way out, things that bring you short-term comfort, but never seem to drive you to actually improve. Eg: Arrogance, Ambition',
                )}
                size={'large'}
                style={{ height: 50 }}
                placeholder="Vice"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="faction">
              <Input
                suffix={makeTooltip(
                  'Are you part of a detective agency? police officer? group of nomads? If you belong to some kind of organization, put the name here.',
                )}
                prefix={<GiPoliceBadge />}
                size={'large'}
                style={{ height: 50 }}
                placeholder="Faction"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="group">
              <Input
                suffix={makeTooltip(
                  'If you are divided into groups of players, or just wanna remember which group of friends are playing with your character, put a group name here.',
                )}
                prefix={<GiThreeFriends />}
                size={'large'}
                style={{ height: 50 }}
                placeholder="Group Name"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2>Now for some base stats, most of them are calculated automatically...</h2>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="size" validateTrigger={defaultTriggers}>
              <InputNumber
                onChange={calculateHealth}
                prefix={<GiBodyHeight />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Size (5 for Adult Human)'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="armor">
              <InputNumber
                prefix={<GiChestArmor />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Armor (Usually 0)'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="speed">
              <InputNumber
                prefix={<GiSpeedometer />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Speed (Strength + Dexterity + 5)'}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="initiative">
              <InputNumber
                onChange={calculateInitiative}
                prefix={<GiStairsGoal />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Initiative (Dexterity + Composure)'}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="defense">
              <InputNumber
                prefix={<GiSurroundedShield />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Defense (Low of Dex/Wits + Athletics)'}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="health">
              <InputNumber
                prefix={<GiHearts />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Health (Stamina + Size)'}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="willpower">
              <InputNumber
                prefix={<GiDove />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                disabled
                placeholder={'Willpower (Resolve + Composure)'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name="integrity">
              <InputNumber
                prefix={<GiDoubleFaceMask />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Integrity (Starts with 7)'}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2>
              Attributes usually follow the 5/4/3 rule, you choose a line to receive that many
              points on it. This limit will not be automatically enforced because your DM can ask
              for different values, so{' '}
              <span style={{ textDecoration: 'underline', color: 'darkred' }}>NO CHEATING!</span>
            </h2>
          </Col>
          <Divider />
          <Col span={24}>
            <h2>Power attributes</h2>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="intelligence"
              label="Intelligence"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                prefix={<GiBrain />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Intelligence'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="strength"
              label="Strength"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                onChange={calculateSpeed}
                prefix={<GiWeightLiftingUp />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Strength'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="presence"
              label="Presence"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                prefix={<GiMuscleUp />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Presence'}
                controls
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2>Finesse attributes</h2>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="wits"
              label="Wits"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                onChange={calculateDefense}
                prefix={<GiSmart />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Wits'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="dexterity"
              label="Dexterity"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                onChange={() => {
                  calculateDefense()
                  calculateInitiative()
                  calculateSpeed()
                }}
                prefix={<GiArcheryTarget />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Dexterity'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="manipulation"
              label="Manipulation"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                prefix={<GiSpy />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Manipulation'}
                controls
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2>Resistance attributes</h2>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="resolve"
              label="Resolve"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                onChange={calculateWillpower}
                prefix={<GiFist />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Resolve'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="stamina"
              label="Stamina"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                onChange={calculateHealth}
                prefix={<GiDiscobolus />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Stamina'}
                controls
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="composure"
              label="Composure"
              validateTrigger={defaultTriggers}
              rules={[{ required: true }]}
            >
              <InputNumber
                onChange={() => {
                  calculateWillpower()
                  calculateInitiative()
                }}
                prefix={<GiBrainFreeze />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Composure'}
                controls
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2>
              Now, tell us about your skills! Skills usually follow the 11/7/4 rule but again, your
              DM is the boss. Also, you get 3 specialties for free! Choose them at the end!
            </h2>
          </Col>
          <Divider />
          <Col span={24}>
            <h2>
              Mental skills{' '}
              <span style={{ color: '#999999' }}>
                (you get -3 in every test that uses a skill with 0 points)
              </span>
            </h2>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 0, 'academics']}>
              <InputNumber
                prefix={<GiBookCover />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Academics'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 1, 'computer']}>
              <InputNumber
                prefix={<GiComputing />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Computer'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 2, 'crafts']}>
              <InputNumber
                prefix={<GiToolbox />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Crafts'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 3, 'investigation']}>
              <InputNumber
                prefix={<GiMagnifyingGlass />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Investigation'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 4, 'medicine']}>
              <InputNumber
                prefix={<GiHealthNormal />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Medicine'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 5, 'occult']}>
              <InputNumber
                prefix={<GiPentacle />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Occult'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 6, 'politics']}>
              <InputNumber
                prefix={<GiDiploma />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Politics'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 7, 'science']}>
              <InputNumber
                prefix={<GiAtom />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Science'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2>
              Physical skills{' '}
              <span style={{ color: '#999999' }}>
                (you get -1 in every test that uses a skill with 0 points)
              </span>
            </h2>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 8, 'athletics']}>
              <InputNumber
                onChange={calculateDefense}
                prefix={<GiJumpAcross />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Athletics'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 9, 'brawl']}>
              <InputNumber
                prefix={<GiKimono />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Brawl'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 10, 'drive']}>
              <InputNumber
                prefix={<GiCityCar />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Drive'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 11, 'firearms']}>
              <InputNumber
                prefix={<GiPistolGun />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Firearms'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 12, 'larceny']}>
              <InputNumber
                prefix={<GiRobber />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Larceny'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 13, 'stealth']}>
              <InputNumber
                prefix={<GiNinjaHead />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Stealth'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 14, 'survival']}>
              <InputNumber
                prefix={<GiCampfire />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Survival'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 15, 'weaponry']}>
              <InputNumber
                prefix={<GiSwordsEmblem />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Weaponry'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2>
              Social skills{' '}
              <span style={{ color: '#999999' }}>
                (you get -1 in every test that uses a skill with 0 points)
              </span>
            </h2>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 16, 'animalken']}>
              <InputNumber
                prefix={<GiSittingDog />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Animal Ken'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 17, 'empathy']}>
              <InputNumber
                prefix={<GiCherish />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Empathy'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 18, 'expression']}>
              <InputNumber
                prefix={<GiVitruvianMan />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Expression'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 19, 'intimidation']}>
              <InputNumber
                prefix={<GiAngryEyes />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Intimidation'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 20, 'persuasion']}>
              <InputNumber
                prefix={<GiShakingHands />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Persuasion'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 21, 'socialize']}>
              <InputNumber
                prefix={<GiConversation />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Socialize'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 22, 'streetwise']}>
              <InputNumber
                prefix={<GiPayMoney />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Streetwise'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item name={['skills', 23, 'subterfuge']}>
              <InputNumber
                prefix={<GiDominoMask />}
                size={'large'}
                style={{ height: 50, width: '100%' }}
                placeholder={'Subterfuge'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2>
              Now choose 3 specialties!{' '}
              {makeTooltip(
                'A skill specialty is really just a really specific thing to gain advantage on when you are doing. Eg: You have a specialty on Lions with Animal Ken, so whenever dealing with lions, you get bonuses!',
              )}
            </h2>
          </Col>
          <Form.List name="specialties">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name }) => (
                  <Col key={key} xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                      name={[name, 'skill_index']}
                      label="Skill"
                      validateTrigger={defaultTriggers}
                      rules={[{ required: true }]}
                    >
                      <Select
                        style={{ fontFamily: 'HonestMaria' }}
                        options={skillsOptions}
                        placeholder={'Select a skill'}
                      />
                    </Form.Item>
                    <Form.Item
                      name={[name, 'skill_specialty']}
                      label="Specialty description"
                      validateTrigger={defaultTriggers}
                      rules={[{ required: true, whitespace: true }]}
                    >
                      <Input
                        prefix={<GiDiploma />}
                        size={'large'}
                        style={{ height: 50 }}
                        placeholder="Specialty"
                      />
                    </Form.Item>
                    {fields.length > 1 && (
                      <h3 style={{ cursor: 'pointer' }} onClick={() => remove(name)}>
                        <span style={{ fontSize: 18 }}>
                          <MinusCircleOutlined />
                        </span>{' '}
                        Remove specialty
                      </h3>
                    )}
                  </Col>
                ))}
                <Form.Item>
                  {fields.length < 3 && (
                    <h3 style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => add()}>
                      <span style={{ fontSize: 18 }}>
                        <PlusCircleOutlined />
                      </span>{' '}
                      Add specialty
                    </h3>
                  )}
                </Form.Item>
              </>
            )}
          </Form.List>
          <Col span={24}>
            <h2>
              Now select your merits!
              <span style={{ color: '#999999' }}> (up to 7 points)</span>
            </h2>
          </Col>
          <Form.List name="merits">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name }) => (
                  <Col key={key} xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                      name={[name, 'description']}
                      label="Merit description"
                      validateTrigger={defaultTriggers}
                      rules={[{ required: true, whitespace: true }]}
                    >
                      <Input
                        prefix={<GiClover />}
                        suffix={makeTooltip('Please refer to the book for a list of them')}
                        size={'large'}
                        style={{ height: 50 }}
                        placeholder="Merit Description"
                      />
                    </Form.Item>
                    <Form.Item
                      name={[name, 'level']}
                      label="Merit level"
                      validateTrigger={defaultTriggers}
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                        prefix={<GiClockwork />}
                        size={'large'}
                        style={{ height: 50, width: '100%' }}
                        placeholder={'Merit Level'}
                        controls
                      />
                    </Form.Item>
                    {fields.length > 1 && (
                      <h3 style={{ cursor: 'pointer' }} onClick={() => remove(name)}>
                        <span style={{ fontSize: 18 }}>
                          <MinusCircleOutlined />
                        </span>{' '}
                        Remove Merit
                      </h3>
                    )}
                  </Col>
                ))}
                <Form.Item>
                  {fields.length < 7 && (
                    <h3 style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => add()}>
                      <span style={{ fontSize: 18 }}>
                        <PlusCircleOutlined />
                      </span>{' '}
                      Add Merit
                    </h3>
                  )}
                </Form.Item>
              </>
            )}
          </Form.List>
          <Col span={24}>
            <h2>
              Now select your conditions... or not!
              <span style={{ color: '#999999' }}> (You can leave this blank)</span>
            </h2>
          </Col>
          <Form.List name="conditions">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name }) => (
                  <Col key={key} xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                      name={[name, 'description']}
                      label="Condition description"
                      validateTrigger={defaultTriggers}
                      rules={[{ required: true, whitespace: true }]}
                    >
                      <Input
                        prefix={<GiSkullCrack />}
                        suffix={makeTooltip(
                          'Conditions are struggles and penalties you character has to endure, you can negotiate extra skill or merit points with your DM in exchange for acquiring a condition before the game. Please refer to the book for a list of them but do not feel limited by them, you can create new ones',
                        )}
                        size={'large'}
                        style={{ height: 50 }}
                        placeholder="Condition Description"
                      />
                    </Form.Item>
                    <Form.Item
                      name={[name, 'reason']}
                      label="Condition reason"
                      validateTrigger={defaultTriggers}
                      rules={[{ required: true, whitespace: true }]}
                    >
                      <Input
                        prefix={<GiClockwork />}
                        size={'large'}
                        style={{ height: 50 }}
                        placeholder="Condition Reason"
                      />
                    </Form.Item>
                    <h3 style={{ cursor: 'pointer' }} onClick={() => remove(name)}>
                      <span style={{ fontSize: 18 }}>
                        <MinusCircleOutlined />
                      </span>{' '}
                      Remove Condition
                    </h3>
                  </Col>
                ))}
                <Form.Item>
                  {fields.length < 7 && (
                    <h3 style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => add()}>
                      <span style={{ fontSize: 18 }}>
                        <PlusCircleOutlined />
                      </span>{' '}
                      Add Condition
                    </h3>
                  )}
                </Form.Item>
              </>
            )}
          </Form.List>
          <Col xs={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit" size={'large'}>
                Save Character
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <ToastContainer />
      </Form>
    </Overlay>
  )
}
